// AkıllıÇözüm kendi alan adında (akillicozum.com.tr) çalışırken API'yi aynı origin'den çağırır
const isAkilliCozumHost = typeof window !== 'undefined' && /(^|\.)akillicozum\.com\.tr$/i.test(window.location.hostname);

export const RUNTIME_BACKEND_URL = isAkilliCozumHost ? window.location.origin : process.env.REACT_APP_BACKEND_URL;
